import { isNullOrUndefined } from "/Assets/js/utilities.js";
import CampaignSource from "./campaign-source.js";
import LeadSource from "./lead-source.js";

export default class FormMetadataPopulator {
    constructor() {
        this.classNames = [];
        this.singleValue = null;
        this.arrayValues = null;
        this.forms = document.querySelector(".EPiServerForms");
    }

    initWithClassNames(classNames) {
        if (Array.isArray(classNames)) {
            this.classNames = classNames;
        } else {
            this.classNames = [classNames];
        }
        this.populateInputs();
    }

    initWithSingleValue(className, value) {
        this.classNames = [className];
        this.singleValue = value;
        this.populateInputs();
    }

    initWithArrayValues(classNames, values) {
        if (Array.isArray(classNames)) {
            this.classNames = classNames;
        } else {
            throw new Error("classNames must be an array");
        }

        if (Array.isArray(values)) {
            this.arrayValues = values;
        } else {
            throw new Error("values must be an array");
        }
        this.populateInputs();
    }

    populateInputs() {
        if (this.forms === null) return;

        let values;
        if (this.singleValue) {
            values = { [this.classNames[0]]: this.singleValue };
        } else if (this.arrayValues) {
            values = this.classNames.reduce((acc, className, index) => {
                acc[className] = this.arrayValues[index] || "";
                return acc;
            }, {});
        } else {
            values = this.getValues();
        }

        this.classNames.forEach(className => {
            const inputElement = document.querySelector(`.${className}`);
            if (inputElement && values[className]) {
                inputElement.value = values[className];
            }
        });
    }

    getValues() {
        const leadSourceValues = this.getLeadSourceValues();
        const productInterestValues = this.getProductInterestValues();
        const langaugeValue = this.getLanguage();
        const campaignValue = this.getCampaign();
        return {
            ...leadSourceValues,
            ...productInterestValues,
            "ht_preferredcommunicationlanguage": isNullOrUndefined(langaugeValue) ? "en" : langaugeValue,
            "ht_campaignsource": isNullOrUndefined(campaignValue) ? "" : campaignValue,
            "campaign_source": isNullOrUndefined(campaignValue) ? "" : campaignValue
        };
    }

    getCampaign() {
        const campaignSource = new CampaignSource();
        return campaignSource.getCampaignSourceValue();
    }

    getLanguage() {
        return document.documentElement.lang;
    }

    getProductInterestValues() {
        const productInterestData = window.productInterestData;

        if (!productInterestData || Object.keys(productInterestData).length === 0) {
            return this.getDefaultProductInterestValues();
        }
        return this.mapProductInterestData(productInterestData);
    }

    getDefaultProductInterestValues() {
        return {
            "ht_materialshape": "",
            "ht_application": "",
            "ht_platform": "",
            "ht_technologyinterest": "",
            "ht_productclasstype": "",
            "ht_productmodelline": ""
        };
    }

    mapProductInterestData(data) {
        return {
            "ht_materialshape": isNullOrUndefined(data.MaterialShape) ? "" : data.MaterialShape,
            "ht_application": isNullOrUndefined(data.Application) ? "" : data.Application,
            "ht_platform": isNullOrUndefined(data.Platform) ? "" : data.Platform,
            "ht_technologyinterest": isNullOrUndefined(data.Technology) ? "" : data.Technology,
            "ht_productclasstype": isNullOrUndefined(data.ProductClassType) ? "" : data.ProductClassType,
            "ht_productmodelline": isNullOrUndefined(data.ProductModelLine) ? "" : data.ProductModelLine
        };
    }

    getLeadSourceValues() {
        const leadSource = new LeadSource();
        const leadSourceValues = leadSource.getLeadSourceValues();

        return {
            "ht_leadsource": leadSourceValues[0]["ls"],
            "ht_leadsourcedetail": leadSourceValues[0]["lsd"]
        };
    }
}
